export const DependencyPendingEditorNotificationDataHooks = {
  container: 'dependency-pending-editor-notification-container',
  description: 'dependency-pending-editor-notification-description',
};
